export default {
  common: {
    querySpecifications: 'Query technical specifications',
    login: 'Нэвтрэх',
    logout: 'Гарах',
    Home: 'Нүүр хуудас',
    ProductCenter: 'Бүтээгдэхүүний төв',
    WhatIsaSoftwareDefinedCamera: 'Программ хангамжид суурилсан (SDC) камер гэж юу вэ?',
    ProductDetail: 'Product Detail',
    Solutions: 'Шийдэл',
    SolutionsDetail: 'Solutions Detail',
    Products: 'Бүтээгдэхүүн',
    Tools: 'Tools',
    Support: 'Тусламж',
    Documentation: 'Documentation',
    news: 'News Center',
    newsDetail: 'News Detail',
    forPartners: 'For Partners',
    activity:'Activity',
    SoftwareDefinedCamera: 'Software-Defined Camera',
    IntelligentVisionSystem: 'IVS',
    Accessory: 'Accessory',
    ContactUs: 'Contact Us',
    NewsRoom: 'Мэдээ, мэдээлэл',
    NewsRoomDetail: 'News Room Detail',
    Partner: 'Partner',
    Resources: 'Нөөц',
    ResourceCenter: 'Resource Center',
    VideoLibrary: 'Video Library',
    AftersalesSupport: 'Aftersales Support',
    Aftersales: 'Aftersales Q&A',
    Privacy: 'Нууцлалын бодлого',
    TermsOfUse: 'Үйлчилгээний нөхцөл',
    clear:"Clear",
    RefineBy: 'Нарийвчлах',
    placeholder: 'Загвар, нэр, түлхүүр үгийг оруулна уу',
    Favorites: 'Favorites',
    Compare: 'Compare',
    More: 'More',
    all: 'Бүгд',
    enter: 'Загвар, нэр, түлхүүр үгийг оруулна уу',
    enterKeyword: 'Түлхүүр үг оруулна уу',
    resultsFound: 'Илэрц олдлоо: ',
    collapse: 'Нугалах ',
    expand: 'Дэлгэх',
    confirm:"Confirm",
    cancel:"Cancel",
    channel:"Түншүүдийн байршил",
    type: 'төрөл',
    upload: "Хавсралт оруулах",
    submit: 'Илгээх ',
    activityHub:'Activity Hub',
    search: 'Хайх',
  },
  login: {
    title: 'Sign In with User ID',
    email: 'Email',
    pwd: 'Password',
    changePwd: 'Change Password',
    forgetPwd: 'Forget Password',
    register: 'Register',
    rulesEmail: 'Email is invalid',
  },
  //导航栏
  navbar: {
    aboutTitle: 'Бидний тухай',
    about: 'HOLOWITS-н тухай',
    products: 'Бүтээгдэхүүн',
    productCenter: 'Бүтээгдэхүүний төв',
    technicalSupport: 'Тусламж',
    FAQ:'FAQ',
    solution: 'Шийдэл',
    documentation: 'Баримт бичиг',
    support: 'Тусламж',
    certificate: 'Гэрчилгээ',
    pocDemo: 'PoC Demo',
    news: 'Мэдээ, мэдээлэл',
    activityHub: 'Activity Hub', 
    events:'EVENTS',
    tools: 'TOOLS',
    partners: 'Түншүүд',
    resources: 'Нөөц',
    forPartners: 'Хамтралын хөгжүүлэлт',
    forCustomers: 'FOR CUSTOMERS',
    channel:"Түншүүдийн байршил",
    videoLibrary: "Бичлэг",
    contact: "Бидэнтэй холбоо барих",
    // algorithmstore: "ALGORITHM STORE",
    algorithmstore: "Алгоритм",
    terms: "POLICIES, TERMS, CONDITIONS",
    warrantypolicy: "WARRANTYPOLICY",
    firmware: "Дотоод программ",
    software: "Программ хангамж",
    becomeAPartner: 'Хамтран ажиллах',
    dealRegistration: 'Түншлэлийн хэлцэл бүртгүүлэх',
    training: 'Цахим сургалт',
    knowledge: 'Knowledge',
    successfulCases: 'Success Stories'
  },
  home: {
    'whatIsNew': "Шинэ мэдээлэл",
    'ProductSpotlight': 'Онцлох бүтээгдэхүүн',
    'Events&News': 'Онцлох үйл явдлууд & Мэдээ мэдээлэл',
    'learnMore': 'Дэлгэрэнгүй үзэх',
    'e-learning': 'Цахим сургалт',
    'certificate': 'Гэрчилгээ',
    'video': 'Бичлэг',
    'wiki': 'Мэдлэгийн сан'
  },
  //合作伙伴
  partners:{
    banner:{
      title:'HOLOWITS Сертификаттай',
      summery:'Ухаалаг дүрс бичлэгийн мэргэжилтэн',
    },
    introduction:{
      title:'Цахим хичээлийн танилцуулга',
      desc:'Энэхүү сургалт нь HOLOWITS-ийн программ хангамжид суурилсан камерууд (SDC), сүлжээний видео бичигч (NVR), ухаалаг Micro Edge төхөөрөмжүүд болон цогц шийдлүүдийг танилцуулна. Мөн борлуулалтын өмнөх болон дараах техникийн мэдлэг олгох сургалтын материалууд болон шалгалтуудыг багтаасан болно. Та шалгалтаа амжилттай өгснөөр "HOLOWITS-ийн баталгаат ухаалаг дүрс бичлэгийн мэргэжилтэн" сертификат авах боломжтой.',
    },
    course:{
      title:'Сургалтын ач холбогдол ',
      value:'Энэхүү хичээл нь танд HOLOWITS-ийн бүтээгдэхүүн, шийдлүүдийн давуу талуудыг таньж мэдэх, борлуулалтын ур чадвар эзэмших, мөн хэрэглэгчдэд борлуулалтын дараах мэргэжлийн үйлчилгээ үзүүлэхэд тусална.',
    },
    certification:{
      title:'Гэрчилгээг дагалдсан үнэ цэнэ',
      value:'Энэхүү сертификат нь таныг зах зээлд өрсөлдөх давуу талтай болгож, HOLOWITS-ийн бүтээгдэхүүн, шийдэл болон борлуулалтын дараах үйлчилгээний чиглэлээр таны мэдлэг чадварыг батлан харуулна. Мөн захиалагч болон ажил олгогчдод таны мэргэжлийн ур чадварыг хялбархан танихад туслах болно.',
    },
    contents:[
      {text: 'HOLOWITS AI камерын техникийн танилцуулга'},
      {text: 'HOLOWITS AI видео платформын техникийн танилцуулга'},
      {text: 'HOLOWITS HWT-NVR800 техникийн үндсэн танилцуулга (Слайд)'},
      {text: 'HOLOWITS iClient S100 техникийн сургалт'},
      {text: 'HOLOWITS дагалдах хэрэгслийн тохиргооны гарын авлага'},
      {text: 'HOLOWITS Ухаалаг худалдааны шийдэл'},
      {text: 'HOLOWITS Ухаалаг хотхоны шийдэл'},
      {text: 'HOLOWITS Ухаалаг эрчим хүчний сүлжээний шийдэл'},
      {text: 'HOLOWITS Ухаалаг тээврийн шийдэл'},
      {text: 'HOLOWITS S200 техникийн сургалт'},
      {text: 'Объект таних камерын суурилуулалтын өмнөх судалгаа болон ашиглалтад оруулах товч заавар'},
      {text: 'ePolice (Замын хяналтын) камерын суурилуулалтын өмнөх судалгаа болон ашиглалтад оруулах товч заавар'},
      {text: 'HOLOWITS HWT-NVR800 суурилуулалт болон ашиглалтад оруулах заавар'},
      {text: 'HOLOWITS HWT-IVS1800 суурилуулалт болон ашиглалтад оруулах заавар'},
      {text: 'HOLOWITS A цувралын камер болон XVR-ийн танилцуулга'},
      {text: 'HOLOWITS Аппликейшн ашиглах заавар'},
      {text: 'HOLOWITS E цувралын камерын танилцуулга'},
    ],
    learningGuide:{
      title:'Суралцах заавар',
      desc:'Шалгалтад тэнцэхийн тулд холбогдох материал болон видео хичээлүүдийг анхааралтай судална уу. Сертификат авснаас хойш хоёр жил тутамд сунгаж, шинэчлэх шаардлагатай.',
      text:'Эхний удаа нэвтрэхэд бүртгүүлэх шаардлагатай',
      registerCode:'Registration code: ',
      registerValue:'UJIQ-RVH-PQW',
      btnValue:'Шалгалт өгөх',
    },
  },
  //关于Holowits
  aboutHWT:{
    label: {
      'Company Profile': 'Байгууллагын нүүр хуудас ',
      'Who is HOLOWITS': 'HOLOWITS гэж хэн бэ',
      'HOLOWITS Offering': 'HOLOWITS бүтээгдэхүүн, шийдлүүд ',
      'Business Overview': 'Бизнесийн тойм',
      'Culture & Value': 'Бидний соёл, үнэт зүйл',
      'Quality Policy': 'Чанарын бодлого',
      'Data Security': 'Дата өгөгдлийн аюулгүй байдал',
      'Cyber Security': 'Кибер аюулгүй байдал',
      'Sustainable Development': 'Тогтвортой хөгжлийн бодлого',
    },
    one: {
      wshtw: `HOLOWITS гэж хэн бэ`,
      ov: `Бидний зорилго`,
      title1: `Бүх зүйлийг мэдрэх ухаалаг ертөнцийн төлөө`,
      title2: `Бидний тухай`,
      content: `HOLOWITS бол олон хэмжээст мэдрэх технологид суурилсан хиймэл оюун ухаант интернэт зүйлс (AIoT) бүтээгдэхүүн, шийдлийн дэлхийн хэмжээний нийлүүлэгч бөгөөд судалгаа шинжилгээ (R&D), үйлдвэрлэл, түгээлт, борлуулалт болон үйлчилгээний цогц чадамжийг өөртөө нэгтгэсэн компани юм. HOLOWITS нь ухаалаг мэдрэгч технологи, иж бүрэн үйлдвэрлэлийн сүлжээ болон техникийн хүчирхэг дэмжлэг үзүүлэх чадвартай.
Дэлхий даяар өсөн нэмэгдэж буй ухаалаг технологийн хэрэгцээнд нийцүүлэн HOLOWITS нь Хиймэл оюун ухаант камер (AIC), Видео шинжилгээний ухаалаг платформ (VIP) болон үүлэн үйлчилгээг хөгжүүлэхийн төлөө ажиллаж байна. Эдгээр бүтээгдэхүүн, шийдлүүдийг ухаалаг хот, ухаалаг тээвэр, ухаалаг эрчим хүч, ухаалаг үйлдвэрлэл, ухаалаг хотхон болон ухаалаг худалдаа зэрэг олон төрлийн салбарт ашиглах боломжтой. Бид бүх зүйл мэдрэх чадвартай ухаалаг ертөнцийг хамтдаа цогцлоохыг зорьдог. Үүний тулд дэлхийн зах зээлд аюулгүй, найдвартай, ашиглахад хялбар бөгөөд шилдэг бүтээгдэхүүн, шийдлүүдийг нийлүүлэхэд бүх анхаарлаа хандуулан ажиллаж байна.`
    },
    two: {
      content1: `HOLOWITS бүтээгдэхүүн, шийдлүүд `,
      content2: `IPC-ээс AIC хүртэл хувьсал`,
      content3: `Программ хангамжаар тодорхойлогдох архитектур: "Үйлдэлт камераас" "Ухаалаг камер" руу шилжих шилжилт`,
      content4: `1960-аад оны аналог камер`,
      content5: `Оптик болон цахилгаан-механик`,
      content6: `1990-ээд оны IP камер`,
      content7: `Тусгайлсан хэрэглээнд зориулагдсан камер`,
      content8: `2020-оод оны хиймэл оюун ухаант камер`,
      content9: `Хиймэл оюун ухаанаар тогтмол ажиллах ухаалаг камер`,
      content10: `Өмнөх үеийн камерууд `,
      content11: `Хязгаарлагдмал тооцоолол хийх хүчин чадалтай камер`,
      content12: `Хиймэл оюун ухаант камер`,
      content13: `AI камерын технологийн хөгжлийн чиг хандлага нь уламжлалт гар утаснаас ухаалаг гар утас руу шилжсэн хувьсалтай туйлын төстэй гэдэгт бид итгэдэг. Энэхүү томоохон ахиц дэвшил, хувьсгалт боломжуудаар тодорхойлогдож буй шилжилт нь AI камерын салбарыг шинэ шатанд гаргаж, дүрс бичлэгийн орчин нөхцөлийг үндсээр нь өөрчлөх болно гэж үзэж байна.`,
      content14: `AI ROOT Technologies (компанийн нэр)`,
      content15: `HOLOWITS-н бусдаас ялгарах давуу тал юу вэ?`,
      content16: `Ухаалаг мэдрэгч технологийн салбарт HOLOWITS нь хиймэл оюун ухааны үндсэн суурь болсон (root) дэвшилтэт технологиудыг эзэмшдэг.`,
      content17: `AI ROOT технологид суурилсан бүтээгдэхүүнүүд`,
      // content18: `SuperColor`,
      // content19: `Challenges`,
      // content20: `Light compensation is required under low-lit conditions`,
      // content21: `Traditional ISP optimization has reached the bottleneck`,
      // content22: `Interferences caused by rain and dust lead to poor-quality images`,
      // content23: `Crystal-clear night visioin with 0 light pollution`,
      content99: `HOLOWITS нь AI камер болон платформуудаараа дамжуулан ухаалаг тээвэр, хот, хотхон, худалдааны салбарын шийдлүүдийг хөгжүүлэхийн тулд түншүүдтэйгээ нягт хамтран ажилладаг. Энэ нь хэрэглэгчдэдээ үр ашигтай удирдлага, үйлчилгээний шинэчлэл болон бизнесийн амжилтад хүрэхэд нь тусалдаг. HOLOWITS нь бүх зүйл мэдрэх чадвартай ертөнцийг цогцлооход хувь нэмэр оруулах бүтээгдэхүүн, үйлчилгээг тасралтгүй нийлүүлж, ажил болон амьдралыг илүү хялбар, илүү ухаалаг болгож байна.`
    },
    three: {
      content1: `Бизнесийн тойм`,
      content2: `Бизнесийн алсын хараа`,
      content3: `HOLOWITS-н багийнхны хувьд: Бид өргөн сүлжээгээр түгээлтийг шуурхай хийх нь хэчнээн чухал болохыг сайн мэддэг. Тиймээс дэлхийн өнцөг булан бүрд хүрч , бүтээгдэхүүн, үйлчилгээгээ хэрэглэгчдэдээ хүртээмжтэй хүргэхийн төлөө хичээн ажиллаж байна.`,
      content4: `Манай түгээлтийн сүлжээ нь тив дамнан өргөжсөн бөгөөд дэлхийн зах зээлийн гол цэгүүдэд борлуулагчид маань стратегийн дагуу байршсан байдаг. Энэхүү өргөн хүрээтэй сүлжээ нь бүтээгдэхүүнээ шуурхай, үр ашигтайгаар хүргэх боломжийг олгож, хэрэглэгчиддээ хамгийн сайн үйлчилгээг үзүүлэх боломжийг олгодог. `,
      content5: `Түншлэгчдийн самбар`,
      content6: `HOLOWITS нь өөрийн түгээлтийн сүлжээг өргөжүүлэн бэхжүүлэхийн тулд тасралтгүй ажиллаж байна. Бид дэлхийн өнцөг булан бүрд хүрч, шинэлэг, тогтвортой бөгөөд эрчим хүчний хэмнэлттэй шийдлүүдээ хаана ч байсан хэрэглэгчдэдээ хүргэхийг зорьдог. Та бидэнтэй хамтран ажиллах хүсэлтэй боломжит борлуулагч эсвэл манай бүтээгдэхүүнийг сонирхож буй хэрэглэгч байсан ч илүү ухаалаг, тогтвортой ертөнцийг бүтээх бидний аялалд нэгдэхийг урьж байна.`,
    },
    four: {
      content1: `Бидний соёл, үнэт зүйл`,
      content2: `Бид олон талт байдлыг хүлээн зөвшөөрч, дэмжих нь бүтээлч сэтгэлгээ болон инновацыг хөгжүүлэх үндэс суурь болдог гэдэгт бат итгэдэг тул HOLOWITS-ийн зүгээс олон талт, хүртээмжтэй орчныг бүрдүүлэхийн төлөө хичээнгүйлэн ажилладаг.`,
      content3: `Бид шинэ үзэл баримтлал, хандлагыг ямагт талархан хүлээн авдаг бөгөөд шинэ сорилтуудыг даван туулж, инновацыг бүтээхийг эрмэлздэг хувь хүн бүрд боломж олгож, дэмжлэг үзүүлэхэд бэлэн байна.`,
      content4: `HOLOWITS-д ажиллана гэдэг нь эрч хүчтэй багийн нэг хэсэг болж, хамгийн сүүлийн үеийн дэвшилтэт технологийг хамтдаа бүтээж, ашиглана гэсэн үг юм. Мөн энэ нь хувь хүн болон мэргэжлийн хувьд өсөн дэвжих боломж бөгөөд танд чадварлаг мэргэжилтэн, мөн бие хүн болон хөгжих өргөн боломжууд нээлттэй байх болно.`,
    },
    five: {
      content1: `Чанарын бодлого`,
      content2: `HOLOWITS-ийн хувьд бид хэрэглэгчдэдээ хамгийн өндөр чанартай бүтээгдэхүүн, үйлчилгээг хүргэхийг эрмэлздэг. Манай хяналтын үйл явц маш өргөн хүрээнд, өндөр түвшинд явагддаг тул нийлүүлж буй бүтээгдэхүүн бүр стандартын шаардлагыг бүрэн хангана.`,
      content3: `Бид IBM зэрэг дэлхийд тэргүүлэгч компаниудын туршлагаас санаа авч, чанарын удирдлагын системээ нэвтрүүлсэн. Энэхүү систем нь бүтээгдэхүүн хөгжүүлэлт, үйлдвэрлэл, үйлчилгээний бүхий л шат дамжлагыг хамардаг тул чанартай гүйцэтгэлийг хангуулах боломжийг бүрдүүлдэг. `,
      content4: `Бид чанарын үзүүлэлтийг хамгийн чухалд тооцон олон улсын стандартыг мөрдлөг болгон ажилладаг. Тодруулбал: Чанарын удирдлагын ISO9001, байгаль орчны менежментийн ISO14000, хөдөлмөрийн эрүүл мэнд, аюулгүй байдлын ISO45000, Мэдээллийн технологийн үйлчилгээний менежментийн ISO20000 болон мэдээллийн аюулгүй байдлын ISO27000 зэрэг гэрчилгээг эзэмшдэгээрээ бахархдаг. Эдгээр батламжууд нь чанар, аюулгүй байдал болон тогтвортой хөгжлийн төлөөх бидний тууштай байдлын илэрхийлэл юм. `,
      content5: `HOLOWITS-ийн хувьд чанар гэдэг нь зөвхөн стандарт хангах төдий зүйл биш, харин хэрэглэгчийн хүлээлтээс давуулан биелүүлэх явдал юм. Бид хэрэглэгчдэдээ хамгийн шилдэг туршлагыг мэдрүүлэхийн тулд бүтээгдэхүүн, үйлчилгээ болон дотоод үйл ажиллагаагаа тасралтгүй сайжруулахыг эрмэлзэн ажилладаг.`,
    },
    six: {
      content1: `Дата өгөгдлийн аюулгүй байдал`,
      content2: `HOLOWITS-ийн хувьд таны өгөгдөл, мэдээллийг хамгаалах нь зөвхөн хариуцлага биш, харин бидний хамгийн чухал амлалт юм. Бид мэдээллийн аюулгүй байдлыг хэрхэн иж бүрэн хангадаг талаар дэлгэрэнгүй танилцуулъя:`,
      content3: `Дэлхий даяар байршуулсан үүлэн үйлчилгээний дэд бүтэц: Манай өгөгдлийн төвүүд зөвхөн нэг бүс нутгаар хязгаарлагддаггүй. Бид Сингапур, Арабын Нэгдсэн Эмират, Бразил, Өмнөд Африк болон Ирланд гэсэн дэлхийн таван гол цэгт үүлэн технологийн зангилаа төвүүдээ байгуулсан. Энэхүү дэлхийг хамарсан сүлжээ нь хүртээмж болон үр ашгийг нэмэгдүүлээд зогсохгүй, гэнэтийн байгалийн гамшиг эсвэл аваарын үед өгөгдлийг нөөцлөх, эргэн сэргээх найдвартай байдлыг хангадаг.`,
      content4: `Хамгаалалтад зориулсан загвар шийдэл: Манай өгөгдлийн төвүүд нь хэрэглэгчийн мэдээллийг хамгаалах тал дээр архитектурын төгс шийдэл болсон байгууламжууд юм. Төв бүрд физик аюулгүй байдал, орчны хяналт болон болзошгүй аюулаас урьдчилан сэргийлэх хамгийн сүүлийн үеийн дэвшилтэт технологиудыг нэвтрүүлсэн. Энэхүү бат бөх суурь бааз болон манай программ хангамжийн шинэлэг хамгаалалтууд нь дэд бүтцийг салбартаа хамгийн аюулгүйд тооцогдохуйц болгож байгаа юм.`,
      content5: `Хууль тогтоомжийн хэрэгжилт болон түүнээс дээгүүрт: Бид үүлэн үйлчилгээний төвүүд байрлаж буй улс орон бүрийн хууль тогтоомж, дүрэм журмыг чанд мөрдөхөөс гадна өгөгдлийн аюулгүй байдал болон нууцлалыг хангах тал дээр хэрэглэгчдэдээ бүрэн амлалт нь өгч чадна. Энэ нь зөвхөн хууль биелүүлэхээс хамаагүй илүү зүйл бөгөөд хэрэглэгчдийнхээ итгэлийг хүлээж, түүнийгээ хадгалах тухай асуудал юм. `,
      content6: `Нууцлалын дэвшилтэт протоколууд: Бидний хувьд өгөгдөл нууцлал бол дараа нь бодох зүйл биш, харин хамгийн анхны стандарт юм. Бид хамгийн орчин үеийн шифрлэлтийн аргуудыг ашигладаг бөгөөд энэ нь таны чухал мэдээллийг дамжуулах болон хадгалагдах үед ч зөвшөөрөлгүй хэн нэгэн этгээдийн хараанаас найдвартай хамгаална гэсэн үг.`,
      content7: `Аюул заналыг урьдчилан илрүүлэх ба хариу арга хэмжээ: HOLOWITS-ийн хувьд бид хамгийн сайн хамгаалалт бол довтолгоо гэж үздэг. Тиймээс манай системүүд аливаа алдаа болон гарч болзошгүй аюул заналыг байнга хянаж байдаг. Аюулыг илрүүлэх дэвшилтэт чадамжийнхаа тусламжтайгаар бид зүгээр нэг хариу үйлдэл үзүүлдэггүй, харин аюул занал бий болохоос өмнө тэдгээрийг идэвхтэйгээр тодорхойлж, саармагжуулдаг.`,
      content8: `24/7 Хамгаалалтын хяналт: Өдөр бүр, минут тутамд манай өгөгдлийн гол бүсүүд хатуу хяналтад байдаг. Аливаа хэвийн бус үйлдэл илэрмэгц манай ослын үед хариу арга хэмжээ авах найдвартай протокол идэвхжиж, шуурхай арга хэмжээ авах болон гарч болзошгүй нөлөөллийг хамгийн бага түвшинд байлгахаар ажилладаг.`,
      content9: `Тасралтгүй сайжруулалт: Кибер аюул заналхийлэл цаг минут тутамд хувьсан өөрчлөгдөж буй өнөө үед олсон амжилтдаа тайвшрах эрх бидэнд байхгүй. Бид систем, үйл ажиллагаа болон арга техникээ тасралтгүй сайжруулах замаар өөрсдийгөө ямагт хөгжүүлсээр байна. Тогтмол аудит, нэвтрэх туршилт (penetration testing) болон сургалтуудыг тогтмол явуулснаар HOLOWITS нь өгөгдөл хамгаалах технологийн оргилд байр сууриа баттай хадгалсаар байна.`,
    },
    seven: {
      content1: `Кибер аюулгүй байдал`,
      content2: `HOLOWITS-ийн хувьд бид тогтвортой хөгжлийг эрхэмлэдэг бөгөөд энэхүү зарчим нь манай бизнесийн стратеги болон технологийн шинэчлэл бүрд гүн шингэсэн байдаг. Бид зөвхөн хэрэглэгчдийнхээ хэрэгцээг хангаад зогсохгүй, байгаль орчинд эерэг нөлөө үзүүлэх шийдлүүдийг бүтээхийг зорьдог.`,
      content3: `Манай тогтвортой хөгжлийн төлөөх амлалт нь хиймэл оюун ухааныг (AI) анхдагч байдлаар ашиглаж буй туршлагаас маань тодорхой харагддаг. Бид AI-ийн хүч чадлыг ашиглан зөвхөн шинэлэг төдийгүй байгаль орчинд ээлтэй бүтээгдэхүүнүүдийг хөгжүүлсээр ирсэн. Манай AI-ийн үндсэн технологиуд болох SuperColor, SuperCoding, болон SuperAI нь энэхүү амлалтын тод жишээ юм.`,
      content4: `SuperColor технологи нь манай AI камеруудад нэмэлт гэрэлтүүлэг ашиглахгүйгээр тод, бүрэн өнгөт дүрсийг буулгах боломжийг олгодог. Энэхүү шинэлэг шийдэл нь гэрлийн бохирдлыг бууруулж, эрчим хүчийг хэмнэх замаар илүү ногоон, тогтвортой орчинг бүрдүүлэхэд хувь нэмэр оруулдаг.`,
      content5: `SuperCoding хэмээх манай өөр нэгэн гол технологи нь видео дамжуулалт болон хадгалалтыг оновчтой болгодог. Энэ нь видео дүрсийг урд талын гол хэсэг (foreground) болон арын дэвсгэр (background) гэж салгаж, хөдөлгөөнтэй байгаа хэсэгт ердийн кодчилол, харин арын дэвсгэр хэсэгт гүнзгийрүүлсэн кодчилол (depth coding) ашигладаг. Энэхүү процесс нь дамжуулалтын зурвасын өргөн болон хадгалах зайны хэрэгцээг ойролцоогоор 60%-иар бууруулж, эрчим хүчийг ихээхэн хэмнэх боломжийг олгодог.`,
      content6: `SuperAI-ийн тусламжтайгаар манай AI камерын 1 TOPS тооцоолон бодох хүчин чадал нь салбарын бусад камеруудын 2 TOPS-той тэнцэхүйц ажиллаж, нөөцийг хэмнэдэг. Үүний зэрэгцээ манай нээлттэй алгоритмын экосистем нь камерт алгоритмуудыг чөлөөтэй сольж ашиглах боломжийг олгодог. Ингэснээр салбарын бусад тоглогчдын хэд хэдэн камер ашиглаж шийддэг асуудлыг ердөө нэгхэн AI камераар бүрэн шийдвэрлэх боломжтой юм.`,
      content7: `Компанийн зүгээс бид байгаль орчинд ээлтэй, эрчим хүчний хэмнэлттэй шийдлүүдийг бүтээхийг зорьдог. Үүний нэг жишээ болох манай Eco-Cube камер нь сүлжээний болон тэжээлийн кабель шаарддаггүй тул материалын хэрэглээ болон эрчим хүчний зарцуулалтыг эрс багасгадаг. Түүнчлэн, түүний загвар шийдэл нь төхөөрөмжийн засвар үйлчилгээнд нэмэлт хүн хүч шаардах шаардлагагүй болгож, байгаль орчинд үзүүлэх сөрөг нөлөөллийг (environmental footprint) улам бүр бууруулж байгаа юм.`,
      content8: `HOLOWITS-ийн хувьд тогтвортой хөгжил гэдэг нь зүгээр нэг чамин үг биш. Энэ нь манай бизнесийн шийдвэрүүдийг тодорхойлж, инновацыг маань чиглүүлэгч үндсэн зарчим юм. Технологи болон тогтвортой байдал гар гараа барилцан хөгжиж, эх дэлхийгээ илүү эрүүл байлгах, хүн бүрийн сайн сайхан ирээдүйн төлөө бид бүх хүч чадлаа зориулан ажиллаж байна.`,
    },
    eight: {
      content1: `Тогтвортой хөгжлийн бодлого`,
      content2: `HOLOWITS-н хувьд кибер аюулгүй байдал  гэдэг нь хэрэглэгч, бизнес эрхлэгчдэд ямар их ач холбогдолтой болохыг гүнээ ухамсарладаг бөгөөд дэлхийн тэргүүлэх кибер аюулгүй байдлын стандартууд, ялангуяа Үндэсний эмзэг байдлын мэдээллийн сангийн (NVD) стандартыг чанд мөрдөж ажилладаг. Бид аюулгүй, найдвартай бүтээгдэхүүний шийдлүүдийг нийлүүлэх үүрэг хүлээсэн бөгөөд кибер аюулгүй байдлын дэвшилтэт технологиудыг эзэмшиж, үүнийг хамгийн тэргүүний зорилт гэж үздэг. HOLOWITS нь бүтээгдэхүүний программ хангамжийн шинэ хувилбар гаргах бүрдээ гарч болох бүх сул талыг шалгаж, илэрсэн эмзэг байдал бүрийг цаг алдалгүй засдаг. Ил тод байдал болон хянах боломжийг хангах үүднээс эдгээр засварын талаарх дэлгэрэнгүй мэдээллийг манай албан ёсны баримт бичигт тэмдэглэн үлдээдэг. Өнөөдрийг хүртэл зах зээлд нийлүүлэгдсэн манай бүтээгдэхүүнүүдэд ямар нэгэн сул тал илэрч байгаагүй, учир нь бид бүтээгдэхүүнээ гаргахаас өмнө бүх эрсдэлийг бүрэн шалгаж, арилгасан байдаг.`,
      content3: `HOLOWITS нь NVD стандартыг чанд мөрдөж, тус мэдээллийн санд нийтлэгдсэн бүх эмзэг байдлыг цаг алдалгүй засварласнаар бүтээгдэхүүнээ аливаа эрсдэлээс ангид байлгах чадамжтай. Энэ нь кибер аюулгүй байдлын төлөөх бидний амлалтыг харуулаад зогсохгүй, хэрэглэгчдийнхээ мэдээллийн аюулгүй байдалд хэр зэрэг өндөр ач холбогдол өгдгийг илтгэж байгаа юм. Дүгнэж хэлэхэд, HOLOWITS нь кибер аюулгүй байдлыг үргэлж нэгдүгээрт тавьдаг. Технологийн инновац болон удирдлагын хатуу хяналтын тусламжтайгаар HOLOWITS нь бүтээгдэхүүн, үйлчилгээгээрээ дамжуулан хэрэглэгчдэдээ аюулгүй байдлын баталгааг бүрэн олгодог.`,
    }
  },
  // 产品中心
  products: {
    productTypes: 'Бүтээгдэхүүний төрөл',
    filters: {
        'All': 'Бүгд',
        'AI_Camera': 'Хиймэл оюун ухаант камер',
        'Video_Intelligent_Platform': 'Бичлэгийн ухаалаг платформ',
        'IP_Camera_&_NVR': 'IP камерууд ба NVR',
        'Analog_Camera_&_XVR': 'Аналоги камерууд ба XVR',
        'Transmission': 'Дамжуулах төхөөрөмж',
        'Display_&_Control': 'Дэлгэц болон Удирдлагын хэсэг',
        'Professional_Sound': 'Мэргэжлийн дууны төхөөрөмжүүд',
        'Entrance_&_Exit_Management': 'Орц, гарцын удирдлага',
        'Public_Address': 'Зарлан нийтлэх систем',
        'Intelligent_Collaboration': 'Ухаалаг хамтын ажиллагаа',
        'Management_System': 'Удирдлагын систем',
        'Alarm': 'Дохиолол',
        'Accessories': 'Дагалдах хэрэгсэл',
        'HOLOWITS_Selected': 'HOLOWITS-н онцлох бүтээгдэхүүн',
        'HOLOWITS_Souvenir': 'HOLOWITS-н бэлэг дурсгал',
        'Box_Camera': 'Box камер',
        'Bullet_Camera': 'Bullet камер',
        'Fixed_Dome_Camera': 'Dome камер',
        'PTZ_Dome_Camera': 'Эргэдэг (PTZ) камер',
        'AR_Panorama_Camera': 'AR Panorama камер',
        'Distribution/Project': 'Түгээлт / Төсөл',
        'AI_Function': 'Хиймэл оюун ухаант үйлдлүүд',
        'Sensor_Size': 'Мэдрэгчийн үйлдлүүд',
        'Focal_Length': 'Фокусын урт',
        'Illuminator_Type': 'Гэрэлтүүлгийн төрөл',
        'Illumination_Distance': 'Гэрэлтүүлгийн зай',
        'IP_Rating': 'Гадна орчны хамгаалалтын зэрэг (IP)',
        'IK_Rating': 'Цохилтын хамгаалалтын зэрэг (IK)',
        'Port': 'Оролт / Гаралт (Порт)',
        'Resolution': 'Нягтаршил',
        'SuperCoding': 'Супер кодчилол (Бичлэгийн хэмжээ хэмнэх технологи)',
        'Vehicle_Analysis': 'Тээврийн хэрэгслийн дүн шинжилгээ',
        'Object_Classification': 'Объектыг төрөлжүүлэн таних',
        'Omni-data_Structuring': 'Олон төрөлт өгөгдлийн бүтэцжүүлэх (Omni-data)',
        'Auto_Tracking': 'Автомат мөрдлөг хийх',
        'Behavior_Analysis': 'Зан төлөвийн дүн шинжилгээ',
        'Multi-algorithm_Switchover': 'Олон алгоритм хооронд шилжих',
        'Target': 'Бай (Объект) таних',
        'Traffic_Flow_Statistics': 'Замын хөдөлгөөний урсгалын статистик',
        'Vehicle_Event_Detection': 'Тээврийн хэрэгслийн зөрчил илрүүлэлт',
        'Crowd_Flow_Analysis': 'Хүний бөөгнөрөл, урсгалын шинжилгээ',
    },
    sort: 'Sort',
    overAll: 'Overall',
    hot: 'Hot',
    latest: 'New',
    listPrice: 'List Price',
    preSales: 'Pre-Sales',
    model: 'Model',
    processor: 'Processor',
    memory: 'Memory',
    computingPower: 'Computing',
    Series: 'Цуврал',
    Form: 'Маягт',
    More: 'Илүү мэдээлэл',
  },
  // 产品详情
  productDetail: {
    productDetail: 'Details',
    accessoryDetail: 'accessoryDetails',
    specifications: 'Specifications',
    certification: 'Certification',
    introduction: 'Introduction',
    download: 'Download',
    documentation: 'Documentation',
    huaweiCcsc: 'imgs/product_detail/mapen.png',
    clickHere: 'Click Here',
    dataSheet: 'Datasheet',
    afterSalesDocuments: 'After-Sales Documents',
    copy: 'Copy',
    reportError: 'Report Error',
    description: 'Description',
    describeError: 'Please describe the error you found.',
    picture: 'Picture',
    onlyJpg: 'Only the .jpg format is supported.',
    attachment: 'Attachment',
    selectFile: 'Select File',
    anonymous: 'Anonymous',
    submit: 'Submit',
    accessory: 'Accessory',
    technicalSpec: 'Technical Spec',
    dimensions: 'Dimensions',
    remarks: 'Remarks',
    optionalFitting: 'Optional Fitting',
    favorites: 'Favorite',
    keySpec: 'Key Spec',
    viewAll: 'Log In to View All',
    clicktoLoad: 'Download',
    completeSpecificationList: 'Complete Specification List',
  },
  // solutions
  solutions: {
    Industry: 'Салбар',
    Region: 'Бүс нутаг',
    Type: 'Төрөл',
    Solution: 'Шийдэл',
    successStories: 'Амжилтын түүхүүд',
    filters: {
      'Campus Sensing': 'Хотхоны хяналтын систем',
      'Transportation Sensing': 'Тээврийн хяналтын систем',
      'City Sensing': 'Хотын хяналтын систем',
      'Africa': 'Африк',
      'Asian Pacific': 'Ази, Номхон далайн бүс',
      'Europe': 'Европ',
      'Latin America': 'Латин америк',
      'Middle East': 'Ойрх дорнод ',
      'Other': 'Бусад',
    }
  },
  // knowledge
  knowledge: {
    "Type": "Төрөл",
    "All": "Бүгд",
    "HOLOWITS Academy": "HOLOWITS Академи",
    "Industrial Knowledge": "Салбарын мэдлэг",
    "HOLOWITS AIoT": "HOLOWITS AIoT",
    "Solution": "Шийдэл"
  },
  // 技术支持
  support: {
    wahtDoYouNeedHelpWith: 'What do you need help with?',
    title: 'Welcome to HOLOWITS Technical Support',
    explain: 'HOLOWITS Technical Support provides first-class support for your HOLOWITS products and solutions. Our online support services and engineers around the world are ready to help you anytime, anywhere.',
    documentation: 'Баримт бичиг',
    softwareDownload: 'Software Download',
    video: 'Бичлэг',
    searchPlaceholder: 'Түлхүүр үг оруулна уу',

    "HOLOWITS_Support": 'HOLOWITS-н техник туслалцаа',
    "Wiki": 'Мэдлэгийн сан (Wiki)',
    "Firmware": 'Системийн программ (Firmware)',
    "Software": 'Программ хангамж',
    "Knowledge": 'Мэдлэг, зааварчилгаа',
    "E-learning": 'Цахим сургалт',
    "Policy,Terms": 'Бодлого болон Үйлчилгээний нөхцөл',
    "Announcement": 'Зар мэдээ',
    "AI Camera": 'Хиймэл оюун ухаант камер',
    "Video Intelligent Platform": 'Видео шинжилгээний ухаалаг платформ',
    "IP Camera & Analog Camera": 'IP камер, Аналог камер',
    "NVR & XVR": 'NVR/XVR',
    "Software": 'Программ хангамж',
    "Cloud Service": 'Үүлэн (Cloud) үйлчилгээ',
    "Solution": 'Шийдэл',
    "Other": 'Бусад',
    "Tools": 'Хэрэгслүүд',
    "Calculate Bandwidth": 'Сүлжээний ачаалал тооцоолох (Bandwidth)',
    "Calculate Recording Capacity": 'Бичлэгийн багтаамжийг тооцоолох',
    "NVR Access": 'NVR холболт / хандалт',
    "Calculate Cameras Detection Distance": 'Объект таних зайг тооцох',
    "IP System Design Tool": 'IP системийн зураг төслийн багаж',
    "MD5 Checker": 'Файлын бүрэн бүтэн байдлыг шалгах / MD5 Шалгагч',
  },
  contact: {
    theme: 'Техникийн дэмжлэг хэрэгтэй юу?',
    content: 'Техникийн дэмжлэг авахын тулд өөрийн улс эсвэл бүс нутгийн HOLOWITS албан ёсны борлуулагч дистрибьюторт хандана уу.',
    tip1: 'HOLOWITS-ийн борлуулагч дистрибьютор болон дахин борлуулагчидтай холбогдох',
    tip2: 'Техникийн дэмжлэгийн талаар HOLOWITS-тай холбогдохыг хүсвэл доорх имэйл хаягаар холбогдоно уу.',
    tip3: 'Ажилд авах асуудлаар HOLOWITS-тай холбогдохыг хүсвэл доорх имэйл хаягаар холбогдоно уу.',
    button1: 'Энд дарна уу',
    button2: 'support@holowits.com',
    button3: 'hr@holowits.com',
    title: '',
    explain: '',
    tip4_1: '香港支店：HOLOWITS TECHNOLOGIES HK LIMITED',
    tip4_2: '住所：香港ワンチャイヘネシー通り253-261番EASEY COMMビル10階1002号室',
    tip4_3: 'メール：support@holowits.com',
  },
    // 渠道中心
  channel: {
    partnerName: 'Түншийн нэр',
    countryOrRegion: 'Улс/Бүс нутаг',
    partnerType: 'Түншийн төрөл',
    searchPlaceholder:"Түншүүдийн жагсаалтаас хайх",
    website: 'Вэбсайт',
    email: 'Имэйл',
    phone: 'Утас',
    address: 'Хаяг'
  },
  // 新闻中心
  news: {
      searchPlaceholder: 'Түлхүүр үг оруулах',
      search: 'Хайх',
  },
  // 客户举办的活动
  activityHub: {
      title: 'Үйл ажиллагааны төв',
      smallTitle: 'Түншүүдийн үйл ажиллагаа, нийгмийн сүлжээний мөчүүд, хамтын нийгэмлэгийн агшин'
  },
  // 安防工具
  securityTools: {
    cameradetectionDistance: 'Объект таних зайг тооцох',
    disable: 'Disable',
    enable: 'Enable',
    videoResolution: 'Бичлэгийн нягтаршил',
    encodingBitRate: 'Мэдээлэл дамжуулах хурд',
    NumberOfNVRs: 'Number of NVRs',
    NumberOfSDCs: 'Number of SDCs',
    microCheckpoint: 'Micro checkpoint',
    ePoliceCheckpoint: 'ePolice/Checkpoint',
    targetDetection: 'Target detection/recognition',
    calculateBandwidth: 'Сүлжээний ачаалал тооцоолох (Bandwidth)',
    calculateRc: 'Бичлэгийн багтаамжийг тооцоолох ',
    NVRAccess: 'NVR холболт / хандалт',
    ipTools: 'IP системийн зураг төслийн багаж',
    md5: ' MD5 Шалгагч',
    //提示信息
    microResolutionTips: 'Микро хяналтын цэгийн горимд улсын дугаарын нягтрал дор хаяж 80 пиксел байхыг зөвлөж байна.',
    microInstallationTips: 'Хувилбарын эгнээнд суурилуулах өндөр нь 4.5 м-ээс 6 м хүртэл байхыг зөвлөж байна. Кампусын орох болон гарах хэсэгт суурилуулах өндөр нь 1.3 м-ээс 1.5 м хүртэл байхыг зөвлөж байна. Та суурилуулах өндрийг талбайн шаардлагад үндэслэн тохируулж болно.',
    ePoliceResolutionTips: 'In ePolice mode, the license plate resolution must be greater than or equal to 100 pixels. In checkpoint mode, if only license plates need to be captured, the license plate resolution must be greater than or equal to 100 pixels. If targets inside vehicles also need to be captured, the license plate resolution must be greater than or equal to 180 pixels. ',
    ePoliceInstallationTips: 'The recommended installation height ranges from 5.5 m to 6.5 m.',
    targetResolutionTips: 'Target detection: For short-focus (less than 12 mm) cameras, the recommended target resolution is at least 80 pixels. For medium- and long-focus (12 mm or more) cameras, the recommended target resolution is at least 120 pixels. Target recognition: For short-focus (less than 12 mm) cameras, the recommended target recognition is at least 110 pixels. For medium- and long-focus (12 mm or more) cameras, the recommended target resolution is at least 120 pixels.',
    targetInstallationTips: 'Target detection: For cameras with a fixed focal length of 2.8 mm or 3.6 mm, the recommended installation height ranges from 2 m to 2.5 m. For cameras with a fixed focal length of 6 mm, the recommended installation height ranges from 2 m to 3 m. For cameras with other focal lengths, the recommended installation height ranges from 2.5 m to 3.5 m. Target recognition: For short-focus cameras, the recommended installation height ranges from 2.5 m to 3 m. For long-focus cameras, the recommended installation height ranges from 2.5 m to 3.5 m.',
  },

  // 提示信息
  tipInfo: {
    exportFailure: 'Export failure.',
    addProToComp: 'Add the product to compare.',
    selectLeastTwo: 'Select at least two products for comparison.',
    selectMaximum: 'You can select a maximum of four products for comparison.',
    copySuccess: 'Copy success.',
    noData: 'No data.',
    selectOther: 'The selected device is no data. Please select another device.',
    onlyJpg: 'Only JPG images are supported.',
    exeNoUpload: 'EXE files cannot be uploaded.',
    problemNotEmpty: 'The problem description cannot be empty.',
    submitSuccess: 'Submitted successfully.',
    submitFailed: 'Submission failed. Try again later.',
    loginSuccess: 'Login success',
    errorPwd:'The two passwords are inconsistent',
    confirmLogout:'Confirm to exit the current account?',
    tooManyRequest:'Getting the authentication code is too frequent. Please try again in 3 minute',
    getCodeImageFailed:'Failed to get image verification code',
  },
  technologySupport: {
    support: 'Тусламж',
  },
  // 文档中心
  documentation: {
    searchPlaceholder: 'Түлхүүр үг оруулна уу',
    search: 'хайлт',
    type: 'төрөл',
    productFilter: 'Бүтээгдэхүүн',
    solutionFilter: 'Шийдэл',
    distributionFilter: 'Дистрибюшн',
    typeFilter: 'Хувилбарууд',
    filters: {
      General: 'Ерөнхий',
      AIC: 'AIC',
      VIP: 'VIP',
      'IP Camera & NVR': 'IP камер & NVR',
      'Analog Camera & XVR': 'Аналог камер & XVR',
      'Transmission': 'Дамжуулагч',
      'Display & Control': 'Дэлгэц ба Удирдлагын систем',
      'Entrance & Exit Management': 'Орц, гарцын удирдлага',
      'Public Adress': 'Албан ёсны хаяг',
      'Management System': 'Удирдлагын систем',
      'Accessories': 'Дагалдах хэрэгслүүд',
      'Alarm': 'Дохиолол',
      'HOLOWITS Selected': 'Шилдэг бүтээгдэхүүний цуврал',
      'Network Keyboard': 'Сүлжээний удирдлагын гар',
      'Decoder': 'Хөрвүүлэгч төхөөрөмж',
      'Encoder': 'Бичлэг кодлогч төхөөрөмж',
      'LED Display': 'LED дэлгэц',
      'Access Control': 'Хандах эрхийг хянах',
      'Electric Gate': 'Цахилгаан хаалт ба Гүйдэг хаалганы систем',
      'Parking Management': 'Зогсоолын удирдлага',
      'Parking Guidance': 'Зогсоолын чиглүүлэг',
      'Video Intercom': 'Бичлэгийн интерком',
      'Loudspeaker': 'Чанга яригч',
      "Microphone": "Микрофон",
      "Intercom Terminal": "Дотуур холбооны терминал",
      "Server": "Сервер",
      "Amplifier": "Өсгөгч",
      "Star PA": "Зарлан мэдээлэх нэгдсэн систем",
      "VMS": "Видео удирдлагын систем",
      "Intelligent Campus": "Хотхоныг ухаалгаар удирдах систем",
      "Intelligent Traffic": "Замын хөдөлгөөнийг ухаалгаар удирдах хяналтын систем",
      "Intelligent City": "Хотыг ухаалгаар хянах систем",
      "Target Recognition Application": "Объект таних аппликейшн",
      "Alarm Host": "Дохиоллын удирдлага",
      "Zone Module": "Бүсчлэлийн модуль",
      "Detectors": "Дэлгэцүүд ба Илрүүлэгч төхөөрөмжүүд",
      "Software": "Программ хангамж",
      "Accesories": "Дагалдах хэрэгслүүд",
      "Power Station": "Эрчим хүчний станц",
      "Pre-Sales Communication": "Борлуулалтын өмнөх харилцаа",
      "After-Sales Service": "Борлуулалтын дараах үйлчилгээ",
      "Training": "Сургалт",
      "Marketing": "Маркетинг",
      "Bidding": "Тендер",
      "Partner Operation": "Түншийн үйл ажиллагаа",
      "Datasheet": "Техникийн үзүүлэлт ",
      "Overview Presentation": "Ерөнхий танилцуулга",
      "Technical Presentation": "Техникийн танилцуулга",
      "High Level Design": "Өндөр түвшний дизайн",
      "White Paper": "Цагаан ном",
      "Sales Guide": "Борлуулалтын гарын авлага",
      "Competitive Positioning": "Өрсөлдөх чадамж ба Зах зээлийн байр суурь",
      "Product Sales List": "Борлуулах бүтээгдэхүүний жагсаалт",
      "Star Product Introduction": "Голчлох бүтээгдэхүүний танилцуулга",
      "POC Test Guide": "POC тест хийх гарын авлага",
      "Naming Rules": "Нэршлийн дүрмүүд",
      "Analyst Report": "Шинжээчийн тайлан",
      "Demo Video": "Танилцуулга бичлэг",
      "Deployment Guide": "Системд нэвтрүүлэх заавар",
      "User Guide": "Хэрэглэгчийн гарын авлага",
      "Firmware": "Микро программ",
      "Quick Start Guide": "Нэвтрүүлэх гарын авлага",
      "Release Note": "Шинэ хувилбарын мэдээлэл",
      "Acceptance Guide": "Хүлээн авах гарын авлага",
      "Interface Document": "Холболтын заавар",
      "Product Document": "Бүтээгдэхүүний баримт бичиг",
      "Maintenance Guide": "Засвар үйлчилгээний гарын авлага",
      "Version Mapping": "Программ хангамжийн хувилбаруудын уялдаа",
      "Product Manual": "Бүтээгдэхүүний гарын авлага",
      "Pre-Sales": "Борлуулалтын өмнөх",
      "Post-Sales": "Борлуулалтын дараах",
      "Presentation": "Танилцуулга",
      "EDM": "Маркетингийн цахим шуудан",
      "Product Picture": "Бүтээгдэхүүний зураг",
      "Advertisement & Poster": "Зар сурталчилгааны самбар",
      "Invitation Letter": "Урилгын захидал",
      "Exhibition Material": "Үзэсгэлэнгийн материал",
      "VI & KV": "VI & KV",
      "Promotional Video": "Сурталчилгааны бичлэг",
      "Product & Solution Video": "Бүтээгдэхүүн, шийдлийн бичлэг",
      "Handbook": "Гарын авлага",
      "Rollup": "Сурталчилгааны самбар",
      "News & Advertorial": "Мэдээ, сурталчилгааны нийтлэл",
      "Brochure & Catalog & Portfolio": "Танилцуулга, Каталог болон Бүтээлүүд",
      "Case Study": "Хэрэгжүүлсэн төслүүдийн жишээ",
      "Authorization Letter": "Итгэмжлэх хуудас",
      "JMF": "Ажлын захиалга",
      "Specification List": "Техникийн үзүүлэлтийн жагсаалт",
      "Bidding Guide": "Тендерийн гарын авлага",
      "Configuration Manual": "Тохиргооны гарын авлага",
      "Reliability Prediction Report": "Найдвартай байдлын урьдчилсан тайлан",
      "Quotation Guide": "Үнийн саналын гарын авлага",
      "EU Declaration of Conformity": "Европын шаардлагыг хангасан батламж бичиг",
      "Compatibility List": "Тохиргоо нийцлийн жагсаалт",
      "Award & Qualification": "Шалгалт, баталгаажуулалт болон Шагнал",
      "Technical Proposal Template": "Техникийн саналын загвар",
      "Certification and Test Report": "Гэрчилгээ болон тестийн тайлан",
      "Partner Certification": "Түншлэлийн гэрчилгээ",
      "Terms": "Журам, нөхцөл",
      "Warranty": "Баталгаа"
    },
    languageFilter: 'Хэл',
    formatFilter: 'Формат',
    publishDate: 'Гарсан огноогоор эрэмбэлэх',
    downloadTimes: 'Таталтын тоогоор эрэмбэлэх',
    hotDoc: 'Халуун баримт',
    result: 'үр дүн',
    download: 'Татах',
    share: 'Хуваалцах',
    batDownload: 'Бөөнөөр татах',
    checkAll: 'Бүгдийг сонгох',
    paginalNumber: 'Хуудасны тоо',
    loginTips: 'Нэмэлт агуулгыг үзэхийн тулд нэвтэрнэ үү',
    login: 'Нэвтрэх',
  },
  // 视频中心
  videoLibrary: {
    title: 'Видеоны жагсаалт',
    searchVideo: 'Видео хайх',
    all: 'Бүгд',
    branding: 'Брэнд танилцуулга',
    products: 'Бүтээгдэхүүн',
    solutions: 'Шийдэл',
    technicalSupport: 'Техникийн дэмжлэг',
    training: 'Сургалт',
    hOLOWITSClub: 'HOLOWITS клуб',
    algorithm: 'Алгоритм',
    technologies: 'Технологийн мэдээлэл'
  },
  faq: {
    faq: 'FAQ',
    Products: 'Products',
    Solutions: 'Solutions',
    Partners: 'Түншүүд',
    Marketing: 'Marketing',
    Others: 'Others',
    placeholder: 'leave blank and you get all FAQs',
    help: 'How to use FAQ search'
  },
  learnRegister: {
    tips: "Зөвлөгөө",
    note: "Анхаар: Шалгалтын бүртгэл үүсгэхээс өмнө баруун дээд буланд байрших хувийн бүртгэлээр нэвтэрнэ үү.",
    noteOther: "Эс бөгөөс шалгалтын бүртгэлийн хүсэлт илгээгдэхгүй.",
    pageTitle: "HOLOWITS итгэмжлэгдсэн мэргэжилтний шалгалтын бүртгэл",
    pageDesc1: "Доорх маягтыг бөглөнө үү.",
    pageDesc2: "Баталгаажсаны дараа бид танд имэйл илгээх болно.",
    hint1: "Компанийн ажилтан гэдгээ баталгаажуулна уу (ажилтны үнэмлэх эсвэл нэрийн хуудсаа байршуулж болно)",
    hint2: "Компанийн үйл ажиллагааны тусгай зөвшөөрлийг байршуулна уу (нэмэлт)",
    required: "Энэ талбарыг бөглөх шаардлагатай.",
    upload: "Байршуулах",
    successPanelTitle: "Амжилттай илгээгдлээ",
    successPanelText: "Өргөдөл хүлээн авсан бөгөөд админ танд имэйлээр холбогдох болно.\nХэрэв танай компани манай итгэмжлэгдсэн 2-р түвшний түнш болохыг хүсвэл бүртгүүлэх энд дарна уу. Танай компанийн нэг ажилтан HOLOWITS итгэмжлэгдсэн мэргэжилтний шалгалтыг давсан тохиолдолд танай компани манай итгэмжлэгдсэн 2-р түвшний түнш болж, манай вэбсайтад бас байршина.",
    inputPlaceholder: "HOLOWITS-ийн мэргэжилтний шалгалтад оролцох шалтгаанаа товч тайлбарлана уу"
  },
  register: {
    register: "Бүртгүүлэх",
    email: "Ажилтны имэйл хаягаа оруулна уу",
    companyName: "Компанийн бүтэн нэр",
    name: "Таны нэр",
    country: "Улс/Бүс нутаг",
    description: "Танай компани болон HOLOWITS-ийн түншийн төрлийг тодорхойлно уу",
    code: "Баталгаажуулах код",
    cancel: "Цуцлах",
    submit: "Илгээх",
    successPanelTitle: "Амжилттай илгээгдлээ",
    successPanelText: "Өргөдөл хүлээн авсан бөгөөд бид тантай имэйлээр холбогдох болно.",
    back: "Буцах",
    rules: {
      email: "Имэйл хоосон байж болохгүй.",
      companyName: "Нэр хоосон байж болохгүй.",
      name: "Нэр хоосон байж болохгүй.",
      country: "Улс/Бүс нутаг хоосон байж болохгүй.",
      description: "Тайлбар хоосон байж болохгүй.",
      code: "Код хоосон байж болохгүй."
    }
  },
  bind: {
    successPanelText: "Өргөдөл хүлээн авсан бөгөөд бид тантай имэйлээр холбогдох болно.",
  },
  reseller: {
    pageTitle: "Түнш болох",
    companyName: "Компанийн нэр",
    webSite: "Албан ёсны вэбсайтын хаяг",
    region: "Бүс нутаг",
    coopCountry: "Улс/Бүс нутаг",
    distributor: "Борлуулагч дистрибьютор",
    preSales: "Борлуулалтын өмнөх дэмжлэгийн имэйл хаяг",
    postSales: "Борлуулалтын дараах дэмжлэгийн имэйл хаяг",
    marketing: "Маркетингийн дэмжлэгийн имэйл",
    email: "Тантай холбогдох имэйл",
    companyEmail: "Компанийн бүртгэл болгон бүртгүүлэх имэйл хаяг",
    phone: "Борлуулалтын өмнөх дэмжлэгийн утасны дугаар",
    address: "Компанийн хаяг",
    partnerType: "Түншийн төрөл",
    uploadLog: "Компанийн логоны өндөр нарийвчлалтай графикийг байршуулна уу (jpg эсвэл png)",
    upload: "Байршуулах",
    downlaod: "Гэрээний загварыг татах",
    businessLicense: "Компанийн үйл ажиллагааны тусгай зөвшөөрлийг байршуулна уу (50MB-аас ихгүй файл) (PDF, png, jpg, jpeg, webp форматыг дэмжинэ)",
    agreeFieldText: "HOLOWITS компани миний компанийг HOLOWITS вэбсайтад байршуулахыг зөвшөөрч байна.",
    successPanelTitle: "Амжилттай илгээгдлээ",
    successPanelText: "Өргөдөл хүлээн авсан бөгөөд админ танд имэйлээр холбогдох болно.",
    uploadTips: "Файлыг татаж аваад хэвлэж, холбогдох мэдээллээр бөглөж, гараар гарын үсэг зурсны дараа сканнердсан файлын хуулбарыг байршуулна уу.",
  },
  training: {
    documentation: "Баримт бичиг",
    "Scenario": "Хэрэглээний орчин (Сценари)",
    "Pre-sales": "Борлуулалтын өмнөх үйлчилгээ",
    "Post-sales": "Борлуулалтын дараах үйлчилгээ",
    "Product": "Бүтээгдэхүүн",
    "AI Camera": "Ухаалаг камер",
    "IP Camera/Analog Camera": "IP камер / Аналог камер",
    "Video Intelligent Platform": "Видео шинжилгээний ухаалаг платформ",
    "NVR/XVR": "NVR/XVR",
    "VMS": "VMS",
    "Accessories": "Дагалдах хэрэгслүүд",
    "Other": "Бусад",
    "Solution": "Шийдэл",
    "Intelligent Campus": "Ухаалаг хотхон",
    "Intelligent City": "Ухаалаг хот",
    "Intelligent Transportation": "Ухаалаг тээвэр",
    "Intelligent Retail": "Ухаалаг худалдаа"
  },
  contactUs: {
    contactUsPricingInfo:'Contact Us Pricing Info',
    contactUs: 'Contact Us',
    options: {
      pricingInfo: 'Pricing/Info',
      serviceRequests: 'Service Requests',
    },
    pricingInfo: {
      Title: 'Бидэнтэй холбоо барих',
      Desc1: 'Доорх маягтыг бөглөнө үү.',
      Desc2: 'Бид тантай холбогдох болно.',
      Mandatory: 'Заавал',
      FirstName: 'Нэр',
      LastName: 'Овог',
      Area: "Бүс нутаг",
      Email: 'Имэйл хаяг',
      Telephone: 'Утасны дугаар',
      telephonePlaceholder: "Бүсийн код-дугаар (жишээ нь) 0066-123456",
      CountryRegion: 'Улс/Бүс нутаг',
      Partner: 'Түнш компани',
      PreferLanguage: 'Хэл',
      preference: 'Хэлний тохиргоогоо сонгоно уу',
      Company: 'Компанийн мэдээлэл',
      company_placeholder: 'Компанийн нэрийг оруулна уу',
      Industry: 'Салбар',
      JobTitle: 'Албан тушаал',
      FavoriteProducts: 'Дуртай бүтээгдэхүүнүүд',
      Budget: 'Төсөв',
      BrieflyPlaceholder: 'Заавал: Төслийн шаардлагыг товч бичнэ үү',
      ConfirmText: 'Би HOLOWITS болон HOLOWITS-ийн итгэмжлэгдсэн түншүүдээс бүтээгдэхүүн, шийдэл, үйлчилгээ, бүтээгдэхүүний талаарх мэдээллийг авахыг зөвшөөрч байна. Хүссэн үедээ захиалгыг цуцлах боломжтой гэдгийг ойлгож байна.',
      Yes: 'Тийм',
      No: 'Үгүй',
      AgreeText: 'HOLOWITS-ийн нууцлалын бодлого, ашиглах нөхцөлийн дагуу HOLOWITS миний хувийн мэдээллийг ашиглах, дамжуулахыг ойлгож, зөвшөөрч байна',
      PrivacyPolicy: 'Нууцлалын бодлого',
      publictiy: 'Танай компанийн нэг ажилтан HOLOWITS итгэмжлэгдсэн мэргэжилтний шалгалтыг давсан тохиолдолд танай компани манай итгэмжлэгдсэн 2-р түвшний түнш болж, манай вэбсайтад бас байршина.',
      TermsOfUse: 'Ашиглах нөхцөл',
      And: 'ба',
      placeholder: 'Оруулна уу',
      submit: 'Нэвтрэх',
      fieldRequired: 'Энэ талбарыг бөглөх шаардлагатай.',
      emailValidator: {
        'at-error': 'Имэйл хаяганд “@” тэмдэг байх ёстой.',
        'account-letter-forbidden': 'Имэйлийн нэр (жишээ нь: Adam.Smith@abc.com) хүчингүй тэмдэгт агуулж байна.',
        'prevDot-error': 'Имэйлийн нэр (жишээ нь: Adam.Smith@abc.com) цэгээр (“.”) эхэлж эсвэл төгсөх ёсгүй.',
        'double-dot-error:': 'Хоёр дараалсан цэг (“.”) хамт байх боломжгүй.',
        'domain-error': 'Домэйн (жишээ нь: Adam.Smith@abc.com) дор хаяж нэг домэйн нэр агуулсан байх ёстой.',
        'length-error': 'Имэйл хаяг 254 тэмдэгтээс хэтрэхгүй байх ёстой.',
        'nextLetter-forbidden': 'Домэйн (жишээ нь: Adam.Smith@abc.com) хүчингүй тэмдэгт агуулж байна.',
        'nextLine-error': 'Домэйн (жишээ нь: Adam.Smith@abc.com) зураасаар (“-“) эхэлж эсвэл төгсөх ёсгүй.',
        'account-length-error': 'Имэйлийн нэр (жишээ нь: Adam.Smith@abc.com) 63 тэмдэгтээс хэтрэхгүй байх ёстой.',
      },
      phoneFormatError: 'Жишээ нь: Бүсийн код (3-6 ОРОН, жишээ нь.0066) Утасны дугаар'
    },
  },
  algorithm: {
    // label: "ALGORITHM STORE",
    label: "Алгоритм",
    // pageTitle: "HOLOWITS Algorithm Store",
    pageTitle: "HOLOWITS Algorithm",
    navOptionTag: "Intelligent Algorithm",
    recommendation: "Related products recommendation",
    rd: "リリース日",
    vud: "最終バージョン更新日",
    selectorItemTitle: {
     "Product Application Scenario": "Product Application Scenario",
     "Algorithm Classification": "Algorithm Classification",
     "Applicable Platform": "適用可能なプラットフォーム",
     "Algorithm type": "アルゴリズムの種類"
    },
    tag: {
     "All": "All",
     "Transportation": "Transportation",
     "Government": "Government",
     "Finance": "Finance",
     "Energy": "Energy",
     "Public Security": "Public Security",
     "Personnel Detection": "Personnel Detection",
     "Intelligent Transportation": "Intelligent Transportation",
     "Text Detection": "Text Detection",
     "Behavior Analysis": "Behavior Analysis",
     "Voice Detection": "Voice Detection",
     "Video Analysis": "Video Analysis",
     "Perimeter Events": "Perimeter Events",
     "Event Detection": "Event Detection",
     "Object Detection": "Object Detection",
     "Detection Analysis": "Detection Analysis",
     "SDC": "SDC",
     "HWT-IVS1800": "HWT-IVS1800",
     "HOLOWITS": "HOLOWITS",
     "HOLOWITS SELECTED": "HOLOWITS厳選",
     "OTHER": "OTHER",
     "Third Party": "サードパーティ"
    },
    label: {
     "Subway": "Subway",
     "Highway": "Highway",
     "Railway": "Railway",
     "Airport": "Airport",
     "Public Transport": "Public Transport",
     "Digital Government": "Digital Government",
     "Bank": "Bank",
     "Insurance": "Insurance",
     "Wind Power": "Wind Power",
     "Solar Energy": "Solar Energy",
     "Electric Power": "Electric Power",
     "Gas": "Gas",
     "Water Conservancy": "Water Conservancy",
     "Petroleum": "Petroleum",
     "Forest": "Forest",
     "City Management": "City Management",
     "Fire Detection": "Fire Detection",
     "Manufacturing": "Manufacturing",
     "Agriculture": "Agriculture",
     "Retail": "Retail",
     "Logistics": "Logistics",
     "Service": "Service",
     "Medical Treatment": "Medical Treatment",
     "Catering Industry": "Catering Industry",
     "Tourism": "Tourism",
     "Education": "Education",
     "Campus": "Campus",
     "Family": "Family",
     "Internet of Things(IoT)": "Internet of Things(IoT)",
     "Target Recognition": "Target Recognition",
     "Personnel Attribute Analysis": "Personnel Attribute Analysis",
     "Overall Target Detection": "Overall Target Detection",
     "License Plate detection": "License Plate detection",
     "Vehicle Attribute Detection": "Vehicle Attribute Detection",
     "Non-standard Vehicle Inspection": "Non-standard Vehicle Inspection",
     "Illegal Detection": "Illegal Detection",
     "Vehicle Detection": "Vehicle Detection",
     "Omni-data Structuring": "Omni-data Structuring",
     "OCR": "OCR",
     "Regulation Breach Detection": "Regulation Breach Detection",
     "Crowd Analysis": "Crowd Analysis",
     "Voice Synthesis": "Voice Synthesis",
     "Voice Identification": "Voice Identification",
     "Video Abstract": "Video Abstract",
     "Perimeter Intrusion": "Perimeter Intrusion",
     "Water Pollution Detection": "Water Pollution Detection",
     "Carrying Dangerous Objects": "Carrying Dangerous Objects",
     "Carrying Prohibited Items": "Carrying Prohibited Items",
     "Construction Machinery Detection": "Construction Machinery Detection",
     "Foreign Matter Detection": "Foreign Matter Detection",
     "Wearing Detection": "Wearing Detection",
     "Equipment Status Detection": "Equipment Status Detection",
     "Instrumentation Detection": "Instrumentation Detection",
     "Defect Detection": "Defect Detection",
     "Remote Sensing": "Remote Sensing",
     "Robot": "Robot",
     "X Series": "X Series",
     "M Series": "M Series",
     "C Series": "C Series",
     "D Series": "D Series",
     "HWT-IVS1800": "HWT-IVS1800",
     "Incidents Detection": "Incidents Detection",
     "HOLOWITS": "HOLOWITS",
     "HOLOWITS SELECTED": "HOLOWITS厳選",
     "OTHER": "その他",
     "Vehicle Detection": "Vehicle Detection",
     "Video Synopsis": "Video Synopsis",
    },
    details: {
      "update tips": "Not available, please wait for the update.",
      "Service Provider": "Service Provider",
      "To contact service provider": "To contact service provider",
      "Service Provider Profile": "Service Provider Profile",
      "tips": "Descriptions on the page are provided by service vendors based on their test results. Actual effects may vary depending on application scenarios. For details about comprehensive product capabilities, contact the store operation team.",
      "tags": {
        "Product Details": "Product Details",
        "Associated Product": "Associated Product",
        "Customer Case": "Customer Case",
        "Customer Evaluation": "Customer Evaluation",
        "Support": "Тусламж"
      },
      smallTags: {
        "Parameters": "Parameters",
        "Introduction": "Introduction",
        "Version": "Version",
        "Highlights": "Highlights",
        "Scenario Requirements": "Scenario Requirements",
        "Graphic presentation": "Graphic presentation",
        "Solution with this algorithm": "Solution with this algorithm",
        "Supporting Applications": "Supporting Applications",
        "User Manual": "User Manual"
      }
    }
   },
   terms: {
    bigTitle: "HOLOWITS-ийн бүтээгдэхүүнийг худалдан авах, дэмжлэг авах, засвар үйлчилгээ хийлгэхтэй холбоотой бодлого, дүрэм, нөхцөлүүдтэй танилцана уу.",
    title1: "Техник туслалцаа",
    title2: "HOLOWITS-н бүтээгдэхүүний баталгаат хугацааны нөхцөл",
    jumpPrompt: "Баталгааны нөхцөлтэй танилцах",
  },
  announcement: {
    bigTitle: "HOLOWITS-ийн бүтээгдэхүүнийг худалдан авах, дэмжлэг авах, засвар үйлчилгээ хийлгэхтэй холбоотой мэдэгдлүүдтэй танилцана уу.",
    title1: "Зар мэдээ",
  },
  specialist: {
    register: "Бүртгүүлэх",
    startLearning: "Суралцаж эхлэх"
  },
  csp: {
    title1: "Түншийн төрөл",
    title2: "Хэл",
    all: "Бүгд",
    "Comprehensive Distributor": "Бүрэн эрхт дистрибьютор",
    "Project-based Distributor": "Төслийн суурьтай дистрибьютор",
    "Reseller": "Дахин борлуулагч",
    "System Integrator": "Систем интегратор",
    "Installer": "Суурилуулагч"
  },
  tools: {
    cameras: "Камерын тоо (Ширхэг)",
    codec: "Кодек",
    scenario: "Scenario",
    videoResolution: "Бичлэгийн нягтаршил ",
    frameRate: "Зургийн давтамж",
    superCoding: "Super Coding",
    bitrate: "Битрейт (kbps)",
    encodingBitRate: "Мэдээлэл дамжуулах хурд (Mbps)",
    streamChannels: "Урсгалын сувгийн тоо (Stream-ийн тоо)",
    packetLossRate: "Packet Loss Rate",
    videoBufferingChannels: "Video Buffering Channels",
    singleImageSize: "Single Image Size",
    imagesUploadedPerSecond: "Images Uploaded Per Second",
    reservedBandwidthCoefficient: "Нөөц зурвасын өргөний коэффициент (Сүлжээний ачааллыг 20-30% нөөцөлж тооцох үзүүлэлт)",
    uploadVia: "Upload via FTP/SFTP",
    disable: "Disable",
    enable: "Enable",
    calculate: "Тооцоолох",
    reset: "Шинэчлэх",
    calculateRecordingCapacity: "Бичлэгийн багтаамжийг тооцоолох ",
    basis: "Үндэслэл / Суурь үзүүлэлт",
    basisVideo: "Бичлэгийн нягтаршил ",
    basisiRate: "Мэдээлэл дамжуулах хурд ",
    encodingFormat: "Кодлох хэлбэр",
    coefficient: "Bit rate fluctuation coefficient",
    storagePeriod: "Хадгалах хугацаа (Хоногоор)",
    result: "Үр дүн",
    forReferenceOnly: "Зөвхөн лавлагааны зориулалттай",
    bandwidthRequired: "Шаардлагатай интернэтийн хурд",
    about: "Тухай",
    viewFormula: "View Formula",
    nvrAccess: "NVR холболт / хандалт",
    capacityRequired: "Шаардлагатай хүчин чадал",
    calculationObject: "Тооцооллын объект",
    obj1: "NVR бичигчийн тоо",
    obj2: "SDC камерын тоо (Software-Defined Camera)",
    model: "NVR-ийн модель (загвар)",
    cameradetectionDistance: 'Объект таних зайг тооцох',
    microCheckpoint: "Бичил хяналтын цэг (Жижиг зам, гарц)",
    ePolic: "Цахим цагдаа / Хяналтын пост (Замын хөдөлгөөний зөрчил илрүүлэх)",
    recognition: "Бай (объект) илрүүлэлт / танилт",
    resolutionRequirement: "Шаардлагатай нягтрал (пикселээр)",
    sensorSize: "Мэдрэгчийн (Сенсор) хэмжээ",
    resolution : "Нягтрал (Өргөн)",
    focal: "Фокусын зай (мм)",
    installationHeight: "Суурилуулалтын өндөр (м)",
    numberOfRrequired: "Шаардлагатай NVR-ийн тоо",
    numberOfAccessible: "Хүртээмжтэй SDC-үүдийн тоо",
    resultLabel1: "Илрүүлэлтийн зай (d)",
    tilt: "Хазайлтын өнцөг (α)",
    diagram: "Диаграмм / Зураг (Тооцооллын схем зураг)",
    designTool: {
      title1: "IP видео системийн зураг төслийн багаж",
      title2: "HOLOWITS-ийн камерууд өгөгдлийн санд нэмэгдсэн",
      title3: "IP видео системийн зураг төслийн багажийг ашиглан та дараах зүйлсийг хийх боломжтой:",
      small1: "Хамгаалалтын системийн үр ашгийг дээшлүүлж, зардлыг бууруулахын зэрэгцээ камер суурилуулах хамгийн оновчтой байршлыг тодорхойлох.",
      small2: "Зорилтот пикселийн нягтралд (PPM/PPF) хүрэхийн тулд дуран болон мэдрэгчид тавигдах шаардлагыг хялбархан, нарийвчлалтай тооцоолох.",
      small3: "Камер бүрийн таних, таньж илрүүлэх, ажиглах, илрүүлэх болон хянах бүсүүдийг талбайн зураг дээр харуулах.",
      small4: "Зураг төслөө хурдан эхлүүлэхийн тулд барилгын давхрын төлөвлөгөөг JPEG, PNG, PDF, TIFF болон AutoCAD DWG (Pro хувилбар) форматаар оруулж ашиглах.",
      small5: "Төлөвлөлтийг хялбарчлахын тулд урьдчилан тохируулсан үзүүлэлт бүхий 10,000 гаруй камерын загварын өгөгдлийн санг ашиглах.",
      small6: "Видео архивын тохиргоонд зориулж сүлжээний зурвасын өргөн болон хадгалах сангийн хэрэгцээг тооцоолох.",
      small7: "Кабелийн шугам сүлжээг төлөвлөж, кабелийн уртыг тооцоолох.",
      small8: "Зураг төслөө экспортолж, үнийн санал эсвэл ажлын даалгаварт хавсаргах.",
      title4: "Татаж авах бол холбоос дээр дарна уу:",
      title5: "Камерын өгөгдлийн санг шинэчлэхийн тулд шинэ хувилбарыг татаж суулгасны дараа /Шинэ хувилбар байгаа эсэхийг шалгах/Ижилсүүлэх (Synchronize) дээр дарна уу"
    },
    md5: {
      title1: 'Файлын бүрэн бүтэн байдлыг шалгах / MD5 Шалгагч',
      introduce1: 'Md5 Шалгагч нь олон тооны файл, фолдерын MD5 хяналтын утгыг (checksum) удирдах, тооцоолох, баталгаажуулахад зориулагдсан үнэ төлбөргүй, хурдан, авсаархан бөгөөд ашиглахад хялбар багаж юм. ',
      introduce2: 'Та HOLOWITS вэбсайтаас татаж авсан системийн программаа баталгаажуулахдаа Md5 шалгагчийг ашиглаж болно.',
      small1: 'Олон файлын MD5 хяналтын утгыг нэгэн зэрэг тооцоолж харуулах.',
      small2: 'Файлд өөрчлөлт орсон эсэхийг MD5 хяналтын утгаар шуурхай шалгах.',
      small3: 'MD5 хяналтын утгыг хялбархан ачаалах, хадгалах, нэмэх, устгах болон шинэчлэх.',
      small4: 'Хэмжээ нь ердөө 300 КБ бөгөөд суулгах шаардлагагүй (portable).',
      title2: 'MD5 хяналтын утга гэж юу вэ?',
      introduce3: 'MD5 хяналтын утга (MD5 hash) нь файлын нэг төрлийн "дижитал хураангуй" юм.',
      introduce4: 'Файлд ямар нэгэн өөрчлөлт, бүр ганц байт өөрчлөлт ороход л энэхүү утга нь өөр болж өөрчлөгддөг.',
      downloadTips: 'Татаж авах бол холбоос дээр дарна уу:'
    }
  },
  firm: {
      label: "Фирмвэрийн таталт",
  },
  soft: {
      label: "Програм хангамжийн таталт",
  },
  newsRoom: {
    label: "Мэдээний өрөө",
    describe: "Мэдээ, зарлал, нэвтрүүлсэн амжилтууд болон бусад",
    learnMore: "Дэлгэрэнгүй"
  },
  dr: {
    label: "DEAL REGISTRATION",
    subject: "Deal List",
    title: "Search Condition",
    state1: "Approved",
    state2: "Disapproved",
    state3: "To be Approved",
    state4: "Closed",
    state5: "Unclosed",
    state6: "Pending",
    state7: "Done",
    state8: "Cancelled",
    column1: "Project Name",
    column2: "Company Name (Applicant)",
    column3: "Expected Date of Order",
    column4: "Approval Status",
    column5: "Status",
    column6: "Expiration Date",
    column7: "End Customers Name"
  },
  drDetails: {
    subject1: "Deal Info",
    title1_1: "Deal Business Type",
    title1_2: "Project Name",
    title1_3: "Company Name (Applicant)",
    title1_4: "Win Odds (%)",
    title1_5: "Expected Date of Order",
    title1_6: "Public Tender",
    title1_7: "Deal Registration Start From",
    title1_8: "Expiration Date",
    title1_9: "Deal Description",
    title1_10: "Deal Background",
    title1_11: "Channel Manger Email",
    subject2: "Project Progress and Difficulties for help",
    title2_1: "Operation",
    title2_2: "Project Progress",
    title2_3: "Difficulties for help",
    title2_4: "Created Date",
    subject3: "Competitors",
    title3_1: "Operation",
    title3_2: "Competitor Name",
    title3_3: "Competitive Product",
    subject4: "Products",
    title4_1: "Operation",
    title4_2: "Product Type",
    title4_3: "Series",
    title4_4: "Model",
    title4_5: "Estimated Quantity",
    subject5: "Trading Parties",
    title5_1: "End Customers",
    title5_2: "Product Type",
    title5_3: "End Customers Name",
    title5_4: "End Custimer Name(Native)",
    title5_5_1: "First Name",
    title5_5_2: "Country/Region",
    title5_6: "Last Name",
    title5_7: "State",
    title5_8: "Email",
    title5_9: "City",
    title5_10: "Office Phone",
    title5_11: "Town",
    title5_12: "Address",
    title5_13: "Web site",
    title5_14: "Postal Code",
    title5_15: "Phone NO.",
    title5_16: "Industry",
    title5_17: "Sub-industry",
    title5_18: "Distributor",
    title5_19: "Company Name",
    title5_20: "Address",
    title5_21: "Location Name",
    title5_22: "Postal Code",
    title5_23: "City",
    title5_24: "Tier 2 Partner (if have)",
    title5_25: "Company Name",
    title5_26: "Address",
    title5_27: "Location Name",
    title5_28: "Postal Code",
    title5_29: "City",
    subject6: "Partner Sales Team",
    title6_1: "Operation",
    title6_2: "MAIN",
    title6_3: "Partner",
    title6_4: "Company Name",
    title6_5: "Role",
    title6_6: "Name",
    title6_7: "Email",
    title6_8: "Office phone",
    tips1_1: "1) For the purpose of HOLOWITS's provision of related services to you, HOLOWITS will collect Your personal data (including name, email, etc.), the personal data will be stored on the servers of HOLOWITS TECHNOLOGIES PTE. LTD. (HOLOWITS) and its affiliates. It may be processed by HOLOWITS and the relevant third party. It may be transferred to the third party's country/region or to locations separate from those where HOLOWITS collects the information, and will be accessed, stored, and processed in the aforesaid locations .For more details about how HOLOWITS processes the data, please see the Privacy Statement. Privacy Statement. ",
    tips1_2: "2) If the data you enter contains the personal information of a third party, please inform the third party of the above and obtain their consent or authorization, too. ",
    link1: "Privacy Statement.",
    tips2_1: "Request to close the deal",
    tips2_2: "(If you select this option, you will not be able to modify or update the content of this deal after it is closed).",
    submit: "Submit",
  }
};
